import { useRef, useState } from 'react';
import { Box, Typography, Divider, Card, Grid, Stack, IconButton } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import * as Yup from 'yup';
import { buildRedirectTranslatedUrl, eliminateOjectNotTruthyValues, isSubmitEnabled, requiredField } from '../lib/helperFuncs';
import { FieldControllerTypes, FieldTypes } from '../components/form_v2/types';
import { Form, Formik } from 'formik';
import FormLayout from '../components/layout/Form/FormLayout';
import FormController from '../components/form_v2/highLevelComponents/FormController';
import { AaadeIcon, GoogleIcon, MicrosoftIcon } from '../../src/assets/index';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import Portal from '../components/Portal';
import UserService from '../services/UserService';
import HttpService from '../services/HttpService';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { decodeRedirectUrl } from '../lib/utils';
import AsyncButton from '../components/AsyncButton/AsyncButton';

interface IRegister {
  email: string;
  password: string;
  confirmPassword: string;
  termsAndConditions: boolean;
}

export const taxisRedirect = async () => {
  location.href = 'https://www1.gsis.gr/oauth2server/oauth/authorize?client_id=TBTCYU16072&response_type=code';
};

const Register = () => {

  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const captchaRef = useRef<ReCAPTCHA>(null);
  const navigate = useNavigate();

  document.title = t('Εγγραφή');

  const initialValues: IRegister = {
    email: '',
    password: '',
    confirmPassword: '',
    termsAndConditions: false
  };

  const RegisterFields =
    [{
      control: FieldControllerTypes.input,
      type: FieldTypes.text,
      label: 'Email',
      name: 'email',
    },
    {
      control: FieldControllerTypes.input,
      type: 'password',
      label: t('Κωδικός'),
      name: 'password',
      require: true,
    },
    {
      control: FieldControllerTypes.input,
      type: 'password',
      label: t('Κωδικός Επαλήθευσης'),
      name: 'confirmPassword',
      require: true,
    },
    {
      control: FieldControllerTypes.checkboxTerms,
      type: FieldTypes.checkboxTerms,
      label: t('Αποδοχή όρων Χρήσης & Ορθότητας Στοιχείων'),
      name: 'termsAndConditions',
      required: true,
      link: true
    }
    ];

  const validationSchema = Yup.object({
    email: Yup.string().required(requiredField).email('Μη αποδεκτή μορφή Email')
      .matches(/^\w+([.-]?\w+)*@\w+([-]?\w+)*(\.\w{2,5}(?!\.\w))$/, 'Μη αποδεκτή μορφή Email'),
    password: Yup.string().required(requiredField)
      .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'Τουλάχιστον οκτώ χαρακτήρες, ένα γράμμα, ένας αριθμός και ένας ειδικός χαρακτήρας'),
    confirmPassword: Yup.string().required(requiredField).oneOf([Yup.ref('password')], 'Οι κωδικοί δεν ταιριάζουν'),
    termsAndConditions: Yup.boolean().required(requiredField).test('checkboxTest', 'Αποδοχή Όρων Χρήσης & Ορθότητας Στοιχείων', (value) => value === true),

  });

  const onSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const token = await captchaRef.current?.executeAsync();
      captchaRef.current?.reset();
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/users/register`,
        eliminateOjectNotTruthyValues({ ...values, token })
      );
      if (response.status === 201) {
        enqueueSnackbar(`${t('Επιτυχής Εγγραφή')}`, { variant: 'success' });
        enqueueSnackbar(`${t('Σας έχει σταλθεί e-mail Επιβεβαίωσης του λογαριασμού σας')}`, { variant: 'success' });
        navigate('/');
      }
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message, { variant: 'error' });
      console.error(error.response.data.message);
    }
    setIsLoading(false);
  };

  // const createSessionFromKeycloak = async (access_token: string) => {
  //   try {
  //     const a = await HttpService.getAxiosClient().get('https://min01-rg40-app01.azurewebsites.net/realms/ekome/gaurav-rest', {
  //       headers:
  //       {
  //         'Authorization': `Bearer ${access_token}`
  //       },
  //       withCredentials: true
  //     });
  //     if (a.status === 204) {
  //       return true;
  //     }
  //     return false;
  //   } catch (error) {
  //     console.log(error);
  //   }

  // };
  // const mockLoginTaxis = async () => {
  //   console.log('mockLoginTaxis');
  //   // const mockTaxisnetData = {
  //   //   email: '',
  //   //   afm: '',
  //   //   firstname: '',
  //   //   lastname: '',
  //   // };

  //   const response = await HttpService.getAxiosClient().post('/users/login/taxisnet');
  //   createSessionFromKeycloak(response.data.access_token);

  // };

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectUrl') || '/location';
  return (
    <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
      {/* <Button variant='contained' onClick={() => alert(UserService.isAuthenticated())}>Auth?</Button> */}
      <Grid item>
        <Formik
          onSubmit={() => undefined}
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={false}
        >
          {formik =>
            (<>
              <Card elevation={4}>
                <CardHeader title={
                  <>
                    <Typography variant='h2' component='div'
                      sx={{ padding: '8px 0' }}>
                      {t('Εγγραφή')}
                    </Typography>
                    <Divider variant='fullWidth' />
                  </>
                }>
                </CardHeader>
                <CardContent>
                  <Form>
                    <FormLayout marginT>
                      {RegisterFields.map((item: any) => {
                        if (Array.isArray(item)) {
                          return <Box display='flex'
                            gap={3}
                            key={item + 'Box'}>
                            {item.map((subEl) => {
                              return (
                                <div style={{ width: '100%' }}
                                  key={subEl.name}
                                >
                                  <FormController
                                    {...subEl}
                                    formik={formik}
                                  />
                                </div>
                              );
                            })}
                          </Box>;
                        }
                        return (
                          <FormController
                            key={item.name}
                            formik={formik}
                            {...item}
                          />);
                      })}
                    </FormLayout>
                    <Box display='flex' justifyContent='center'
                      flexDirection='row' mt={1}
                      mb={1}>
                      <AsyncButton
                        isLoading={isLoading}
                        title={t('Εγγραφή')}
                        disabled={isSubmitEnabled(formik?.errors, formik?.dirty)}
                        onClick={() => onSubmit(formik.values)}
                      />
                    </Box>
                  </Form>
                  <div>
                    <Portal>
                      <ReCAPTCHA
                        size='invisible'
                        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY_INVIS || ''}
                        ref={captchaRef} />
                    </Portal>
                  </div>
                  <Stack direction='row' sx={{ alignItems: 'center', width: 'calc(100% - 32px)', m: 'auto' }}>
                    <Divider variant='fullWidth' sx={{ width: 'calc(50% - 21px)' }} />
                    <Typography component='div' sx={{ padding: '0 14px' }}>{t('Ή')}</Typography>
                    <Divider variant='fullWidth' sx={{ width: 'calc(50% - 21px)' }} />
                  </Stack>
                  <Box my={2} display='flex'
                    alignItems='center'
                    flexWrap='wrap'
                    justifyContent='center'>

                    {/* <IconButton sx={{ ml: 2, mr: 2 }} onClick={() => UserService.doLogin({
                      idpHint: 'facebook',
                      redirectUri: `${buildRedirectTranslatedUrl()}/auth/keycloak/landpage?redirectUrl=${decodeRedirectUrl(redirectTo)}`
                    })}><FacebookIcon viewBox='0 0 48 48' sx={{ height: '40px', width: '40px', borderRadius: '6px' }} />
                    </IconButton> */}

                    <IconButton sx={{ mr: 2 }} onClick={() => UserService.doLogin({
                      idpHint: 'google',
                      redirectUri: `${buildRedirectTranslatedUrl()}/auth/keycloak/landpage?redirectUrl=${decodeRedirectUrl(redirectTo)}`
                    })}><GoogleIcon viewBox='0 0 48 48' sx={{ height: '40px', width: '40px', borderRadius: '6px' }} /></IconButton>
                    <IconButton sx={{ mr: 2 }}>
                      <MicrosoftIcon viewBox='0 0 48 48' sx={{ height: '40px', width: '40px', borderRadius: '6px' }} /></IconButton>
                    <IconButton onClick={taxisRedirect} sx={{ mr: 2 }}>
                      <AaadeIcon viewBox='0 0 48 48' sx={{ height: '40px', width: '40px', borderRadius: '6px' }} />
                    </IconButton>
                  </Box>
                  <Box display='flex' justifyContent='end'
                    mt={3} >
                    <Typography mr={1} variant='h4'>
                      {t('Έχετε ήδη λογαριασμό;')}
                    </Typography>
                    <Link to='/'
                    ><Typography variant='h4'>{t('Σύνδεση')}</Typography></Link>
                  </Box>
                </CardContent>
              </Card>
            </>)
          }
        </Formik>
      </Grid>
    </Grid>
  );
};
export default Register; 